// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/compliance/modals/shared/ModalActionRow.jsx

import React from "react";
import { ActionGroup } from "../../../../design-system/components";

function normalizeVariant(action) {
  const variant = String(action?.variant || "").trim().toLowerCase();
  const className = String(action?.className || "").trim().toLowerCase();

  if (variant === "danger" || className.includes("danger")) return "danger";
  if (variant === "primary" || className.includes("primary")) return "primary";
  if (
    variant === "tertiary" ||
    variant === "ghost" ||
    className.includes("ghost")
  ) {
    return "tertiary";
  }
  return "secondary";
}

export default function ModalActionRow({ actions = [] }) {
  const normalizedActions = (Array.isArray(actions) ? actions : [])
    .filter(Boolean)
    .map((action) => ({
      ...action,
      variant: normalizeVariant(action),
      size: action.size || "small",
    }));

  return (
    <ActionGroup
      actions={normalizedActions}
      density="compact"
    />
  );
}
